import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import { fetchGroupsServices } from '../../services/groups';
import { i18n } from '../../translate/i18n';


export const setGroupsFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_GROUPS_FILTER,
    groupsFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const fetchGroupsSuccess = (groups) => {
  return {
    type: actionTypes.FETCH_GROUPS_SUCCESS,
    groups: groups
  };
};

export const fetchGroupByIdSuccess = (group) => {
  return {
    type: actionTypes.FETCH_GROUPS_BY_ID_SUCCESS,
    group: group
  };
}

export const requestGroupsFail = (error) => {
  return {
    type: actionTypes.REQUEST_GROUPS_FAIL,
    error: error
  };
};

export const requestGroupsStart = () => {
  return {
    type: actionTypes.REQUEST_GROUPS_START
  };
};

export const deleteGroupsSuccess = (group) => {
  return {
    type: actionTypes.DELETE_GROUPS_SUCCESS,
    group: group
  }
}

export const checkDeleteGroupsSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_GROUPS_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateGroupsSuccess = (group) => {
  return {
    type: actionTypes.UPDATE_GROUPS_SUCCESS,
    group: group
  }
}

export const postGroupsSuccess = (group) => {
  return {
    type: actionTypes.POST_GROUPS_SUCCESS,
    group: group
  }
}

export const fetchGroups = (page, limit, search, order, orderBy, documenttypeId) => {
  return dispatch => {
    dispatch(requestGroupsStart());
    dispatch(setGroupsFilter(page, limit, search, order, orderBy, documenttypeId));
    fetchGroupsServices(page, limit, search, order, orderBy, documenttypeId)
      .then(res => {
        dispatch(fetchGroupsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestGroupsFail(err));
      });
  };
};

export const fetchGroupById = (id) => {
  return dispatch => {
    dispatch(requestGroupsStart());
    API.get('/equipmentGroups/' + id)
      .then(res => {
        dispatch(fetchGroupByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestGroupsFail(err));
      });
  };
};

export const deleteGroups = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestGroupsStart());
      API.put('/equipmentGroups/' + index + '/delete')
        .then(res => {
          dispatch(deleteGroupsSuccess(res.data));
          toastr.success(i18n.t('groupsStr.toastr'), `${res.data.name} ${i18n.t('groupsStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestGroupsFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const checkDeleteGroups = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestGroupsStart());
      API.get('/equipmentGroups/' + index + '/checkdelete')
        .then(res => {
          dispatch(checkDeleteGroupsSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestGroupsFail(err));
          resolve('error');
        });
    })
  }
}

export const postGroups = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestGroupsStart());
      API.post('/equipmentGroups', body)
        .then(res => {
          dispatch(postGroupsSuccess(res.data));
          toastr.success(i18n.t('postGroupsStr.toastr'), `${res.data.name} ${i18n.t('postGroupsStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestGroupsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postGroupsStr.toastrError'), i18n.t('postGroupsStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const updateGroups = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestGroupsStart());
      API.put('/equipmentGroups/' + index, body)
        .then(res => {
          dispatch(updateGroupsSuccess(res.data));
          toastr.success(i18n.t('updateGroupsStr.toastr'), `${res.data.name} ${i18n.t('updateGroupsStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestGroupsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateGroupsStr.toastrError'), i18n.t('updateGroupsStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}
